import { PhoneTypes } from 'generated/graphql-types';
import { GetExtensions_extensionsConnection_items } from '../../extension-register/queries/generated/GetExtensions';
import { GetExtensionDetail_extension } from '../queries/generated/GetExtensionDetail';

export interface HackedPhonesDetails {
   phoneId: number;
   phoneType: PhoneTypes;
   deviceTypeId: string | undefined;
   macAddressOrSipUsername: string | undefined;
   isFraud?: boolean;
   isHacked?: boolean;
}

export interface ExtensionHackedFraudDetails {
   isHacked: boolean | null;
   isFraud: boolean | null;
   hackedAndFraudSipUserIds: number[] | null;
   hackedPhones: HackedPhonesDetails[] | null;
}

export function getHackedFraudDetails(getExtensionItem: GetExtensionDetail_extension): ExtensionHackedFraudDetails {
   const hackedFraudDetails: ExtensionHackedFraudDetails = {
      isHacked: getIsHackedFromExtension(getExtensionItem) || null,
      isFraud: getIsFraudFromExtension(getExtensionItem) || null,
      hackedAndFraudSipUserIds: getHackedAndFraudSipUserIdsFromExtension(getExtensionItem) || null,
      hackedPhones: getHackedOrFraudPhonesFromExtensionDetail(getExtensionItem) || null,
   };

   return hackedFraudDetails;
}

export function getIsHackedFromExtension(
   getExtensionItem: GetExtensionDetail_extension | GetExtensions_extensionsConnection_items
): boolean {
   let isHacked = false;
   getExtensionItem.phonesConnection.items.some((phone) => {
      isHacked = phone.sipUsersConnection.items.some((sipUser) => sipUser.isHacked);
      return isHacked;
   });
   return isHacked;
}

export function getHackedOrFraudPhonesFromExtensionDetail(
   getExtensionItem: GetExtensionDetail_extension | GetExtensions_extensionsConnection_items
): HackedPhonesDetails[] | null {
   if (!getExtensionItem.phonesConnection || !getExtensionItem.phonesConnection.items) {
      return null;
   }

   const hackedOrFraudPhoneDetails: HackedPhonesDetails[] = getExtensionItem.phonesConnection.items
      .map((phone) => {
         if (phone.phoneType === PhoneTypes.Softphone || phone.phoneType === PhoneTypes.Appsuite) {
            return phone.sipUsersConnection.items
               .filter((sipUser) => sipUser.isHacked || sipUser.isFraud)
               .map(
                  (sipUser) =>
                     ({
                        phoneId: phone.phoneId,
                        phoneType: phone.phoneType,
                        deviceTypeId: undefined,
                        macAddressOrSipUsername: sipUser.userName,
                        isHacked: sipUser.isHacked,
                        isFraud: sipUser.isFraud,
                     } as HackedPhonesDetails)
               );
         } else if (phone.phoneType === PhoneTypes.Hardphone) {
            const relevantSipUsers = phone.sipUsersConnection.items.filter(
               (sipUser) => sipUser.isHacked || sipUser.isFraud
            );
            return relevantSipUsers.reduce((acc, sipUser) => {
               const devices = sipUser.phone?.devicesConnection.items.map(
                  (device) =>
                     ({
                        phoneId: phone.phoneId,
                        phoneType: phone.phoneType,
                        deviceTypeId: device.deviceTypeId,
                        macAddressOrSipUsername: device.macAddress,
                        isHacked: sipUser.isHacked,
                        isFraud: sipUser.isFraud,
                     } as HackedPhonesDetails)
               );
               return devices ? acc.concat(devices) : acc;
            }, [] as HackedPhonesDetails[]);
         } else {
            return [];
         }
      })
      .reduce((acc, val) => acc.concat(val), []);

   if (hackedOrFraudPhoneDetails.length > 0) {
      return hackedOrFraudPhoneDetails;
   }

   return null;
}

export function getIsFraudFromExtension(
   getExtensionItem: GetExtensionDetail_extension | GetExtensions_extensionsConnection_items
): boolean {
   let isFraud = false;
   getExtensionItem.phonesConnection.items.some((phone) => {
      isFraud = phone.sipUsersConnection.items.some((sipUser) => sipUser.isFraud);
      return isFraud;
   });
   return isFraud;
}

export function getHackedAndFraudSipUserIdsFromExtension(
   getExtensionItem: GetExtensionDetail_extension | GetExtensions_extensionsConnection_items
): number[] {
   const hackedAndFraudSipUserIds = getExtensionItem.phonesConnection.items
      .filter((phone) => phone.sipUsersConnection.items.some((sipUser) => sipUser.isHacked || sipUser.isFraud))
      .map((phone) => {
         return phone.sipUsersConnection.items
            .filter((sipUser) => sipUser.isHacked || sipUser.isFraud)
            .map((sipUser) => sipUser.sipUserId);
      })
      .reduce((acc, val) => acc.concat(val), []);

   return hackedAndFraudSipUserIds;
}
